import request from 'superagent';
import config from '../config';

export function fetchAvailability (callback) {
  fetch(config.availability.url, callback);
}
export function fetchGeometry (callback) {
  fetch(config.geometry.url, callback);
}

export function fetch (url, callback) {
  request
    .get(url)
    .end(function (err, data) {
      if (err) {
        return callback(err);
      }
      callback(null, data.text);
    });
}



// WEBPACK FOOTER //
// ./frontend/react/sim/core/api/index.js